// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_nav-bar__g4vRT {
  background-color: var(--primary-color);
  height: 84px;
  display: flex;
  align-items: center;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Navbar/Navbar.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".nav-bar {\n  background-color: var(--primary-color);\n  height: 84px;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-bar": `Navbar_nav-bar__g4vRT`
};
export default ___CSS_LOADER_EXPORT___;
